<nav aria-label="Page navigation" class="d-inline-block">
	<div class="pagination btn-group">
    <button kui-button *ngFor="let page of pageList" [class.active]="page.active" [color]="page.active ? 'primary' : 'secondary'" class="page-item page-link" (click)="changePage(page.index)" [attr.aria-label]="page.text">
      <span aria-hidden="true" *ngIf="page.text === 'Previous'"><span><kui-icon name="chevron-left"></kui-icon></span></span>
      <span aria-hidden="true" *ngIf="page.text === 'Next'"><span><kui-icon name="chevron-right"></kui-icon></span></span>
      <span [class.sr-only]="page.text === 'Previous' || page.text === 'Next'">{{ page.text }}</span>
    </button>
	</div>
</nav>
